import { ref } from 'vue';
import { useUserStore } from '../stores/user-store';
import { get, httpDelete, IHTTPMethodOptions, post, put } from './utils';
import api from './api';
import { TTowncouncil, TTowncouncilFilterParams, TTowncouncilSortingParams } from '@typedefs/towncouncils';
import { TAPIResponse } from '@typedefs/api';

const newTCId = ref('');
const editedTCRet = ref(null);
const deleteTCSuccess = ref(false);

const addTCError = ref('');
const editTCError = ref('');
const deleteTCError = ref('');

export const getTowncouncilFromUEN = async (id: string, token: string, signal?: AbortSignal) => {
  const params: Partial<IHTTPMethodOptions> = { token };

  if (signal) {
    params.signal = signal;
  }
  return get<TAPIResponse<TTowncouncil[], TTowncouncilFilterParams, TTowncouncilSortingParams>>(
    api.tc.getSingleFromUEN(id),
    params,
  );
  // return get(api.)
};

export const addNewTC = async (newTC: TTowncouncil) => {
  const fetchData = async () => {
    const userStore = useUserStore();
    if (userStore.isLoggedIn) {
      const requestBody = {
        UEN_TC: newTC.UEN_TC,
        CompanyName: newTC.CompanyName,
        TownName: newTC.TownName,
        Email: newTC.Email,
        Phone: newTC.Phone,
        Address: newTC.Address,
      };

      try {
        const data = await post(api.tc.addTC(), requestBody, {
          token: userStore.accessToken!,
        });

        if (typeof data.results === 'object' && data.results !== null) {
          newTCId.value = data.results.TC_UID;
        }
      } catch (error) {
        addTCError.value = (error as Error).message;
      }
    }
  };

  await fetchData();

  return {
    newTCId,
    addTCError,
  };
};

export const editTC = async (tc_id: string, editedTC: TTowncouncil) => {
  const fetchData = async () => {
    const userStore = useUserStore();
    if (userStore.isLoggedIn) {
      const requestBody = {
        UEN_TC: editedTC.UEN_TC,
        CompanyName: editedTC.CompanyName,
        TownName: editedTC.TownName,
        Email: editedTC.Email,
        Phone: editedTC.Phone,
        Address: editedTC.Address,
      };

      try {
        const data = await put(api.tc.editTC(tc_id), requestBody, {
          token: userStore.accessToken!,
        });

        if (data.results && typeof data.results === 'object' && !data.results.CodeError) {
          editedTCRet.value = await data.results;
        }
      } catch (error) {
        editTCError.value = (error as Error).message;
      }
    }
  };

  await fetchData();

  return {
    editedTCRet,
    editTCError,
  };
};

export const deleteTC = async (tc_id: string) => {
  const fetchData = async () => {
    const userStore = useUserStore();
    if (userStore.isLoggedIn) {
      try {
        await httpDelete(api.tc.deleteTC(tc_id), {
          token: userStore.accessToken!,
        });
        deleteTCSuccess.value = true;
      } catch (error) {
        deleteTCError.value = (error as Error).message;
      }
    }
  };

  await fetchData();

  return { deleteTCSuccess, deleteTCError };
};

export const getTownCouncils = async (params: string, token: string) => {
  return get(api.tc.getAll(params), { token });
};

export const getTownCouncil = async (id: string, params: string, token: string, signal: AbortSignal) => {
  return get(api.tc.getSingle(id, params), { token, signal });
};
